import { t } from '@ctcells/i18n'

import { HALT_GLYPH, haltLineText, type ShownHaltLine } from './haltLine.ts'
import { resumeCheckLabel } from './resumeRouteModel.ts'

/**
 * **작업 상세의 멈춤 한 줄 + 막는 것 목록**(정본 `07` §4.12). 판정은 `haltLine()` 이 서버 칸으로 한다.
 *
 * ⚠ `role="status"` 다 — 경고가 아니라 서버가 알려 주는 사실이다(`halt_reason` 자리와 같은 결).
 * 🔴 목록은 서버 문장 그대로 한 줄씩 — 고치거나 합치지 않는다.
 * 🔴 [재개] 버튼은 여기 없다 — 작업 줄이 진다(활성은 `allowed_commands` 그대로 · `cleared` 면 거기서 주 버튼이 [재개]다).
 * 확인 재개(`confirm`)면 «확인할 것»(`resume_checks` · 사전 글자)을 한 목록 더 보인다 — 체크는 복구 대화에서 한다.
 */
export function HaltLineNotice({ line }: { line: ShownHaltLine }) {
  const blockers = line.blockers
  return (
    <div className={`halt-line halt-line--${line.kind}`} role="status">
      <p className="halt-line__head">
        <span className="halt-line__glyph" aria-hidden="true">
          {HALT_GLYPH[line.kind]}
        </span>
        {haltLineText(line)}
      </p>
      {line.kind === 'confirm' && line.checks.length > 0 ? (
        <ul className="halt-line__list" aria-label={t('halt.checks')}>
          {line.checks.map((check) => (
            <li key={check}>{resumeCheckLabel(check)}</li>
          ))}
        </ul>
      ) : null}
      {blockers.length === 0 ? null : (
        <ul className="halt-line__list" aria-label={t('halt.blockers')}>
          {blockers.map((blocker) => (
            <li key={`${blocker.code}:${blocker.text}`}>{blocker.text}</li>
          ))}
        </ul>
      )}
    </div>
  )
}
